import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getCategory = createAsyncThunk(
  "category/getCategory",
  async (data) => {
    try {
      const response = await fetch("https://api.mobrespos.com/get_image", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json",
        },
      });
      console.log('response', response)
      const categoryResponse = await response.json();
      console.log("categoryREsponse", categoryResponse);
      return categoryResponse;
    } catch (error) {
      console.log("category thunk hatası" + error);
    }
  }
);

export const categorySlice = createSlice({
  name: "categories",
  initialState: {
    category: [],
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.category = action.payload;
        state.isLoading = false;
      })
      .addCase(getCategory.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default categorySlice.reducer;
